import { Box, useMediaQuery, useTheme } from "@mui/material";

export function MetabaseIframe({ metabaseUrl }: { metabaseUrl: string }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  if (metabaseUrl !== "" && !isMobile) {
    return (
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: 0,
          boxShadow: 0,
          padding: 0,
          margin: 0,
          overflow: "hidden",
          flex: 1, // Take remaining space
          display: "flex",
          flexDirection: "row",
          height: "calc(100vh)",
        }}
      >
        <iframe
          frameBorder="0"
          src={metabaseUrl}
          title="Farm-insights"
          style={{
            flex: 1,
            padding: 0,
            margin: 0,
            height: "calc(100vh)",
            width: "100%",
          }}
        />
      </Box>
    );
  } else {
    return <></>;
  }
}
